import type { ModelProductsSearchFilter } from '@app/api/Products';

const numberOrUndefined = (value: string | null) =>
  value != null && value !== '' && !Number.isNaN(+value) ? +value : undefined;

const mapArray = (value?: string | null) =>
  value ? value.split(',').map(Number) : null;

export const searchParamsToObject = (params: URLSearchParams) => {
  const filters: ModelProductsSearchFilter = {
    SearchTerm: params.get('q') ?? null,
    CategoryIds: mapArray(params.get('categories')),
    BrandIds: mapArray(params.get('brands')),
    ItemsPerPage: numberOrUndefined(params.get('ipp')) ?? 20,
    PageN: numberOrUndefined(params.get('p')) ?? 1,
  };

  return { filters };
};
